export enum EmployeeCountEndpoints {
    EmployeeCounts = '/employee-counts'
}